import { createAction, props } from '@ngrx/store'
import { DebitCharge } from './user-payment-methods.state'
import { C4PaymentMethodDetail, C4PaymentMethodDetailRequest } from '@api/http.service'

export enum PaymentMethodTypes {
  PAYMENT_METHOD_TO_EDIT_LOAD = '[PAYMENT_METHOD] Load Payment Method To Edit',
  PAYMENT_METHOD_TO_EDIT_SUCCESS = '[PAYMENT_METHOD] Payment Method To Edit Loaded Successfully',
  PAYMENT_METHOD_TO_EDIT_FAIL = '[PAYMENT_METHOD] Payment Method To Edit Loading Failed',
  SET_PAYMENT_METHOD_TO_EDIT = '[PAYMENT_METHOD] Set Payment Method To Edit',
}

export const PaymentMethodActions = {
  setPaymentMethodToEdit: createAction(
    PaymentMethodTypes.SET_PAYMENT_METHOD_TO_EDIT,
    props<{ payload: DebitCharge }>(),
  ),
  paymentMethodToEditLoad: createAction(
    PaymentMethodTypes.PAYMENT_METHOD_TO_EDIT_LOAD,
    props<{ payload: C4PaymentMethodDetailRequest }>(),
  ),
  paymentMethodToEditSuccess: createAction(
    PaymentMethodTypes.PAYMENT_METHOD_TO_EDIT_SUCCESS,
    props<{ payload: C4PaymentMethodDetail }>(),
  ),
  paymentMethodToEditFail: createAction(PaymentMethodTypes.PAYMENT_METHOD_TO_EDIT_FAIL),
}
